import React from 'react';

const Header = ({ title, subtitle, authStatus }) => {
  return (
    <header className="header">
      <h1>{title}</h1>
      <p className="subtitle">{subtitle}</p>
      {authStatus && <p style={{ fontSize: '0.875rem', marginTop: '1rem' }}>{authStatus}</p>}
    </header>
  );
};

export default Header;
